import * as React from 'react';

import { PanelHeader } from '@wix/wix-base-ui';

interface FeedHeaderProps {
  title: string;
  onClose(): void;
}

const FeedHeader: React.FunctionComponent<FeedHeaderProps> = (props) => {
  return (
    <PanelHeader noHelpBtn removeStripe onClose={props.onClose}>
      {props.title}
    </PanelHeader>
  );
};

FeedHeader.displayName = 'FeedHeader';

export default FeedHeader;
